<template>
  <div class="main-container">
    <div class="d-flex justify-content-between">
      <h1 class="first-header heading-large">
        <i class="fas fa-chart-line mr-2"></i>Favourite Markets
      </h1>
    </div>
    <button v-if="!favCreated" class="btn btn-confirm" @click="openModalMethod">
      Create Favourite Markets
    </button>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
  methods: {
    openModalMethod() {
      this.openModal()
      
    },
    ...mapActions("selectFavourites",["openModal"])
  },
  computed:{
    ...mapState('livePrices', ['refreshSecondsLeft']),
    ...mapState("selectFavourites", ["favCreated","selectFavouritesModal"]),
    canTriggerModalNow(){
        if(this.selectFavouritesModal){
          let element = this.$root.$refs.selectFavourites.$el
          $(element).modal({backdrop: 'static', keyboard: false})
        }
        return this.selectFavouritesModal
    }
  },
  watch:{
    canTriggerModalNow(){}
  }
  
};
</script>
